import React, {useEffect, useState} from "react";
import CustomInput from "../../common/components/CustomInput";
import CustomButton from "../../common/components/CustomButton";
import {eventConstants} from "../../constants";
import Utility, {dispatchAction} from "../../utility";
import categoryService from "../../services/category";
import {connect} from "react-redux";
import Dropzone from "react-dropzone";
import Utils from "../../utility";
import {getSignedURL, uploadFileToS3} from "../../managers/awsService";
import {ThumbnailImg} from "../category/advertisersComponent";
import {Heading, InputColumn, InputRow, MainContainer, UploadButton} from "../../common/atoms/styles";
import {FormField} from "../../common/atoms/formElements";
import CustomSelect from "../../common/components/CustomSelect";


const AddCategoryComponent = (props) => {
    const {isToUpdate, data} = props
    const [name, setName] = useState(data?.name || "");
    const [ARType, setARType] = useState(data?.ARType || "");
    const [isInactive, setIsInactive] = useState(data?.isInactive || false);
    const [media, setMedia] = useState(data?.media || undefined);
    const [parentCategory, setParentCategory] = useState([]);
    const [selectedParent, setParent] = useState(undefined);

    const getCategoryList = async () => {
        props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(
            categoryService.getParentCategoryList(),
        );
        props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err) return Utility.apiFailureToast("Unable to fetch category");
        setParentCategory(res)
        setParent(res?.[0]?._id)
    }

    useEffect(() => {
        getCategoryList().then(() => 'Category Fetched')
    }, []);

    const onFileDrop = async (files) => {
        if (!files || files.length < 1) {
            Utils.apiFailureToast("Unable to find Media");
            return;
        }
        let file = files[0];
        let fileDetail = Utils.getFileName(file.name);
        let companyLogo = Utils.getNewFileName("category", fileDetail.extension);
        let resFromS3 = await uploadFileToS3(file, companyLogo, file.type).catch(
            (err) => {
                Utils.apiFailureToast("Unable to upload media");
                return false;
            },
        );
        let logoURL = await getSignedURL(companyLogo);
        if (!resFromS3 || !logoURL) {
            Utils.apiFailureToast("Unable to upload media");
            return false;
        }
        setMedia(companyLogo);
    };
    const onSubmitCategory = async () => {
        if (!media) {
            return Utility.apiFailureToast("Image Required!");
        }
        const reqData = {name, ARType, media, isInactive: isInactive, parent: selectedParent};
        // if (!isParent) reqData.parentId = selectedParent._id;

        if (isToUpdate)
            reqData._id = data._id;
        props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(
            isToUpdate ? categoryService.updateCategory(reqData) : categoryService.addCategory(reqData),
        );
        props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err) return Utility.apiFailureToast("Unable to add category");
        if (isToUpdate)
            props.closeDialog()
    };
    const acceptanceString = ".jpg, .jpeg, .png, .svg";
    return (
        <MainContainer>
            <Heading>{`${isToUpdate ? 'Update' : 'Add'} Category`}</Heading>
            <InputRow>
                <InputColumn>
                    <FormField isMandatory={true} label='Select Category'>
                        <CustomSelect
                            options={parentCategory}
                            value={selectedParent}
                            onSelect={(e) => setParent(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='Category Name'>
                        <CustomInput
                            placeholder="Enter here"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='ARType'>
                        <CustomInput
                            placeholder="Enter here"
                            value={ARType}
                            onChange={(e) => setARType(e.target.value)}
                        />
                    </FormField>
                    <FormField isMandatory={true} label='Is Inactive ?'>
                        <div style={{display: "flex", justifyContent: "start", alignItems: "start"}}>
                            <input type={"checkbox"} checked={!!isInactive}
                                   onChange={() => setIsInactive(isTrending => !isTrending)}/>

                        </div>
                    </FormField>
                    <FormField isMandatory={true} label='Category Image'>
                        <Dropzone
                            multiple={false}
                            accept={acceptanceString}
                            onDrop={(files) => {
                                onFileDrop(files);
                            }}
                            noClick={true}
                            onFileDialogCancel={() => setMedia(undefined)}
                        >
                            {({getRootProps, getInputProps, open}) => (
                                <div {...getRootProps()} className="outline-none">
                                    <input {...getInputProps()} />
                                    <UploadButton onClick={() => open()}>
                                        {media ? 'Change Logo' : 'Upload Logo'}
                                    </UploadButton>
                                </div>
                            )}
                        </Dropzone>
                    </FormField>
                    {media &&
                        <ThumbnailImg src={getSignedURL(media)}/>
                    }
                    <CustomButton text={isToUpdate ? "Update" : "Save"} onClick={onSubmitCategory}/>
                </InputColumn>
            </InputRow>
        </MainContainer>
    );
};

const mapStateToProps = (state) => {
    return {user: state.user};
};

export default connect(mapStateToProps, {dispatchAction})(
    AddCategoryComponent,
);
